<template>
  <div v-if="caseList && caseList.length" class="content-center">
    <div class="title">案例</div>
    <div class="content">
      <a-carousel autoplay>
        <div v-for="(item, index) in caseList" :key="index" class="item-wapper">
          <img :src="item.coverUrl" alt="">
          <div class="cover">
            <div class="card-title">{{ item.title }}</div>
            <!-- <div class="card-text">{{ item.content }}</div> -->
          </div>
        </div>
      </a-carousel>
    </div>
  </div>
</template>

<script>
import { getOfficialWebsiteCaseList } from '@/apis/index'
export default {
  components: {
  },
  props: {
    title: {
      type: String,
      default: '连锁电商'
    }
  },
  data() {
    return {
      caseList: []
    }
  },
  mounted() {
    getOfficialWebsiteCaseList(this.title).then(res => {
      if (res && res.length) {
        res.forEach(element => {
          element.content = element.content.replace(/<[^<>]+>/g, '')
          element.coverUrl = element.coverUrl || 'https://inews.gtimg.com/newsapp_bt/0/14155745389/1000'
        })
        this.caseList = res
      }
    }).catch(err => {
      this.$message.error(err)
    })
  },
  methods: {

  }
}
</script>

<style scoped>
  .content-center {
    width: 375px;
    height: 312px;
    padding: 30px 0 15px;
    background: url("~@/assets/Mobile/images/solution/case-bg.png") no-repeat;
  }

  .title {
    width: 287px;
    height: 25px;
    margin: 0 auto;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    color: #FFFFFF;
    line-height: 25px;
    margin-bottom: 20px;
  }
  .content {
    width: 343px;
    margin: 0 auto;
  }
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 192px;
  line-height: 192px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}
.ant-carousel .slick-slide img {
  width: 343px;
  height: 192px;
}
.item-wapper {
  /* width: 586px;
  height: 328px;
  margin: 0 5px;
  border-radius: 8px;
  overflow: hidden;
  display: inline-block; */
  position: relative;
}
.cover {
  position: absolute;
  bottom: 20px;
  left: 43px;
  width: 258px;
  height: 22px;
  z-index: 10;
  text-align: center;
}
.card-title {
  width: 258px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
  max-height: 44px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.card-text {
  display: block;
  font-size: 16px;
  padding: 0 30px;
  text-align: left;
  color: #fff;
}
</style>
